import { useQuery } from 'react-query';
import { fetchPaginatedResumeMetadataValues } from 'react-scale/components/GrowthCenter/OnboardingControlPanel/api';
import { ResumeMetadataFields } from '@scale/shared-types';

interface ResumeMetadataValuesResponse {
  values: Array<{
    value: string;
    count: number;
  }>;
  totalPages: number;
  totalTerms: number;
}

export const useGetResumeMetadataValuesQuery = ({
  field,
  search,
  page,
  pageSize,
}: {
  field: ResumeMetadataFields;
  search?: string;
  page?: number;
  pageSize?: number;
}) => {
  return useQuery<ResumeMetadataValuesResponse>({
    queryKey: ['resume-metadata-values', field, search, page, pageSize],
    queryFn: async () => {
      return fetchPaginatedResumeMetadataValues(field, search, page, pageSize);
    },
    enabled: !!field && !!search,
  });
};
